module.exports = __webpack_public_path__ + "img/img_bannner.5d691c0e.png";